/**
 * Client-generated transaction ids (§3.2).
 *
 * Every transaction row carries a `client_uuid` minted here, in the browser, at
 * the point of entry — never by the server and never by the database. It has a
 * unique constraint, so replaying the same write twice is a no-op.
 *
 * This is what makes Phase 4 offline sync a replay queue rather than a rewrite.
 * It is not optional just because Phase 4 has not started.
 */
export function clientUuid(): string {
  return crypto.randomUUID()
}

/**
 * A form holds one id for its whole lifetime: retrying a failed submit must
 * reuse the id, or the retry becomes a duplicate ledger row rather than a no-op.
 * Mint a fresh one only when the form is reset for a new entry.
 */
export interface EntryId {
  current: () => string
  reset: () => string
}

export function createEntryId(): EntryId {
  let value = clientUuid()
  return {
    current: () => value,
    reset: () => {
      value = clientUuid()
      return value
    },
  }
}
